export type PasswordPolicyKey =
  | 'length'
  | 'lowercase'
  | 'uppercase'
  | 'number'
  | 'symbol'
  | 'noPersonal'

export interface PasswordPolicyCheck {
  key: PasswordPolicyKey
  ok: boolean
}

function tokens(value: string): string[] {
  return value
    .toLowerCase()
    .split(/[^a-z0-9]+/)
    .filter(token => token.length >= 3)
}

export function passwordPolicyChecks(password: string, context?: { fullName?: string; email?: string }): PasswordPolicyCheck[] {
  const lowered = password.toLowerCase()
  const localPart = context?.email?.split('@')[0]?.toLowerCase() ?? ''
  const blockedTokens = [
    ...tokens(context?.fullName ?? ''),
    ...(localPart.length >= 3 ? [localPart] : []),
  ]

  const checks: PasswordPolicyCheck[] = [
    { key: 'length', ok: password.length >= 12 && password.length <= 128 },
    { key: 'lowercase', ok: /[a-z]/.test(password) },
    { key: 'uppercase', ok: /[A-Z]/.test(password) },
    { key: 'number', ok: /\d/.test(password) },
    { key: 'symbol', ok: /[^A-Za-z0-9]/.test(password) },
  ]

  if (context) {
    checks.push({ key: 'noPersonal', ok: blockedTokens.every(token => !lowered.includes(token)) })
  }

  return checks
}

export function passwordMeetsPolicy(checks: PasswordPolicyCheck[]): boolean {
  return checks.every(check => check.ok)
}
